import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from 'react-bootstrap-button-loader';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import TextField from "@material-ui/core/TextField";
import MuiAlert from '@material-ui/lab/Alert';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import { sendForgotUserNameEmail } from '@actions/password';
import * as StatusCode from '@scripts/GenericStatusCode';
import * as ForgotUserNameStatusCode from '@scripts/ForgotUserNameStatusCode';
import styles from '@styles/password.module.css';
import { login } from '@utils/redirect';
import AlertAlgo from '@controls/AlertSnack';

function AlertSnack(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    sendButton: {
        backgroundColor: 'var(--color1) !important',
        borderColor: 'var(--color1) !important',
        color: 'var(--color2) !important',
        '&:disabled': {
            backgroundColor: '#bfbfbf !important'
        }
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        whiteSpace: 'pre-line'
    },
    instructionsSmall: {
        fontSize: '13px',
        fontStyle: 'italic'
    },
    button: {
        marginTop: '20px',
        paddingBottom: '20px',
        float: 'right',
    },
    descriptionSteps: {
        margin: '20px'
    },
    formControl: {
        marginTop: '10px'
    }
}));

function UserName(props) {
    const classes = useStyles();
    const [company, setCompany] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [genericError, setGenericError] = React.useState(`${i18next.t('password:validation.message.generic-error')}`);
    const alertRef = useRef(null);

    const { isMultiCompany, isActivatePrefix, defaultCompany } = props;

    useEffect(() => {
        resize();
    }, []);

    const resize = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;

            const customHeight = height - titleBar;

            document.querySelector('#divPassword').style.height = `${customHeight}px`;
            document.querySelector('#divPassword').style.overflowX = 'hidden';
        }, 1000);
    }

    const handleSend = () => {
        var companyCode = company;

        if (companyCode == "") {
            companyCode = defaultCompany;
        }

        sendForgotUserNameEmail(email, companyCode).then(result => {
            let message = '';
            const intervalTimeout = 2000;

            if (result.status === StatusCode.SUCCESSFULL) {
                showMessageSuccess(i18next.t('password:success.message.forgot-username-success'));
                setTimeout(() => {
                    login();
                }, intervalTimeout);
                return;
            }
            else if (result.status === StatusCode.ERROR) {
                if (result.forgotUserNameStatus === ForgotUserNameStatusCode.MORE_THAN_ONE_USER) {
                    message = i18next.t('password:validation.message.forgot-username-more-than_one-user')
                } else if (result.forgotUserNameStatus === ForgotUserNameStatusCode.NO_MATCH) {
                    message = i18next.t('password:validation.message.forgot-username-no-match')
                } else {
                    // Status code not exists
                    message = i18next.t('password:validation.message.generic-error')
                }

                showMessageError(message);
            }
            else {
                // Error
                message = i18next.t('password:validation.message.generic-error')
            }
            showMessageError(message);
        }).catch(error => {
            showMessageError(genericError);
        })
    };

    const onChangeEmail = (event) => {
        setEmail(event.target.value.trim());
    }

    const onChangeCompany = (event) => {
        setCompany(event.target.value.trim());
    }

    const showMessageSuccess = (message) => {
        alertRef.current.showMessageSuccess(message);
    }

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    const showMessageWarning = (message) => {
        alertRef.current.showMessageWarning(message);
    }

    return (
        <div className={styles.rootPassword}>
            <div className={classes.root}>
                <div id="divPassword">
                    <div className={classes.descriptionSteps}>
                        <p className={classes.instructions}>{i18next.t('password:description.forgot-username-instructions')}</p><p className={classes.instructionsSmall}>{i18next.t('password:description.forgot-username-instructions-paren')}</p>
                        <div>
                            {(isMultiCompany || isActivatePrefix) &&
                                <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        id="company"
                                        label={i18next.t('password:form.company')}
                                        value={company}
                                        onChange={onChangeCompany}
                                    />
                                </FormControl>
                            }
                            <FormControl fullWidth className={classes.formControl}>
                                <TextField
                                    id="email"
                                    label={i18next.t('password:form.email')}
                                    value={email}
                                    onChange={onChangeEmail}
                                />
                            </FormControl>
                        </div>
                        <div className={classes.button}>
                            <Button onClick={handleSend} variant="success" className={classes.sendButton}>
                                {i18next.t('password:button.send')}
                            </Button>
                        </div>
                    </div>
                </div>
                <AlertAlgo ref={alertRef} />
            </div>
        </div>
    );
}

export default withNamespaces(['password', 'error'], { wait: true })(UserName);